import {
  LessonActivityLibrary, LessonActivityOnetime,
  LessonActivityPlatformVideo,
  LessonActivityPlatformWorksheet
} from "./lesson-activity.types"
import { Session } from "../session"
import { ActivityCardCommonProps } from "./activity-card"
import moment from "moment/moment"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import reel from "../../../assets/images/services-icon/reel.png"
import awicon from "../../../assets/images/services-icon/coin.png"
import React from "react"
import { ActivityUtil } from "./activity-util"
import { ActivityType } from "../../lesson/activity/activity.types"
import { ActivityCardContextMenu, ActivityCardContextMenuProps } from "./activity-card-context-menu"
import { LessonActivityTraits } from "./lesson-activity.traits"

type HandledTypes = LessonActivityLibrary
  | LessonActivityPlatformVideo
  | LessonActivityPlatformWorksheet
  | LessonActivityOnetime

interface GeneralActivityCardProps {
  activity: HandledTypes;
  sessionData: Session;
  studentKey?: string;
  index: number;
}

const ActivityMetaData: Record<number, {
  typeName: string, isPlatform: boolean
}> = {
  [ActivityType.MY_LIBRARY_TASK]: {
    typeName: 'Task', isPlatform: false
  },
  [ActivityType.MY_LIBRARY_LINK]: {
    typeName: 'Link', isPlatform: false
  },
  [ActivityType.TUTOR_LIBRARY_ITEM]: {
    typeName: 'File', isPlatform: false
  },
  [ActivityType.MY_LIBRARY_VIDEO]: {
    typeName: 'Video', isPlatform: false
  },
  [ActivityType.MY_LIBRARY_WORKSHEET]: {
    typeName: 'Worksheet', isPlatform: false
  },
  [ActivityType.PLATFORM_VIDEO]: {
    typeName: 'Video', isPlatform: true
  },
  [ActivityType.PLATFORM_WORKSHEET]: {
    typeName: 'Worksheet', isPlatform: true
  },
  [ActivityType.ONETIME]: {
    typeName: 'Task (One-time)', isPlatform: false
  }
}

const ManualMarkTypes = [ActivityType.MY_LIBRARY_WORKSHEET, ActivityType.PLATFORM_WORKSHEET]

type CardProps = GeneralActivityCardProps & ActivityCardCommonProps

export const GeneralActivityCard = (props: CardProps) => {

  const { activity, sessionData, studentKey: activityStudentKey, index } = props
  const { checkbox } = props
  const { manualMarkActivity, ...props2 } = props

  const activityMetaData = ActivityMetaData[activity.activity_type];

  const traits = LessonActivityTraits.create(activity);
  const total_coins = traits.coinsTotal;
  const total_question = traits.questionTotal;
  // const total_time = traits.timeTotal;
  const count_answer = traits.attemptedQuestionCount;

  let manual_mark_review = 0;
  let manualMarkType = ManualMarkTypes.includes(activity.activity_type);
  if(manualMarkType) {
    activity.LessonActivitiesQuestions?.forEach( question => {
      manual_mark_review += question.marked_for_manual_marking
    })
  }

  const activityFlowCompleted = manualMarkType
    ? activity.status === 1 && manual_mark_review > 0
    : activity.status === 1

  const manualMarkActivity2: ActivityCardContextMenuProps['manualMarkActivity'] = manualMarkActivity ? {
    enabled:  manualMarkType && manualMarkActivity.enabled
      && manual_mark_review === 0 && activity.status === 1
      && sessionData?.session?.fk_tut_key === activity.fk_tut_key,
    onActivate: manualMarkActivity.onActivate
  } : undefined;


  return (
    <div className={`${(() => {
      if (
        sessionData?.session?.ses_is_completed === 1
      ) {
        if (activity.status === 1 && activity.mastryScore) {
          const score = activity.mastryScore;
          if (score > 75) return "activity-card-success";
          if (score < 75) return "activity-card-blue";
        }else if(activityFlowCompleted){
          if(activityMetaData.isPlatform) {
            return "activity-card-blue"
          }
          return "activity-card-success";
        }
        return "activity-card-danger";
      }
      return "";
    })()} m-1 set1 bg-supermild`}>
      <div className="d-flex justify-content-between">
        <div>
          <span className="cs-txt-danger font-size-10 me-2">
              {activity?.roll_date ? 'Rolled over from'+ moment(activity.roll_date,moment.ISO_8601).format("DD/MMM/YYYY")
                : null}
          </span>
          <span
            className={`${
              activity.status === 0
                ? "cs-txt-danger"
                : activity.status === 1
                  ? "text-success"
                  : ""
            } font-size-10 me-2`}
          >
          {activity.status === 0
            ? "Incomplete"
            : activity.status === 1
              ? "Completed"
              : null}
        </span>
        <span className={`${
          activity.status === 0
            ? "cs-txt-danger"
            : activity.status === 1
              ? "text-success"
              : ""
          } font-size-10 me-2`}>
          {count_answer != null &&
          total_question != null
            ? count_answer +
            "/" +
            total_question +
            " attempted"
            : null}
        </span>
        <span className="cs-txt-danger font-size-10 me-2">
          {sessionData?.session?.ses_is_completed === 1
            ? activity.mastryScore
              ? `Score: ${activity.mastryScore}`
              : activityFlowCompleted
                ? `Score: 100` : `Score: 0`
            : null}
        </span>
          <OverlayTrigger
            placement={"top"}
            overlay={
              <Tooltip className="custom-tooltip">
                Comment:{" "}
                {activity?.tutor_comments || "No comments available"}
              </Tooltip>
            }
          >
              <span className="no-bdr" style={{ cursor: "pointer" }}>
                <i className="fas fa-info-circle"></i>
              </span>
          </OverlayTrigger>
        </div>
        <div>
        {checkbox?.checkable &&
          <div>
            {(!activityStudentKey || activity.fk_student_key === activityStudentKey) &&
              <>
                <input
                  type="checkbox"
                  checked={checkbox.checked}
                  onChange={checkbox.onCheckedChanged}
                />
              </>}
          </div>
        }
        </div>
      </div>
      <h6 className="text-dark border-bottom pb-1 mb-0 mt-2 font-size-12 lh-sm fw-800">
        {(index + 1) + ") "} {ActivityUtil.activityName(activity)}
      </h6>

      <div className="d-flex justify-content-between mb-2 align-items-center mt-2 flex-wrap">
        <div className="d-flex align-items-center font-size-12 text-dark fw-400">
          <span>
            {" "}
            <img className="me-10" width={24} src={reel} alt=""
            />
          </span>
          {activityMetaData.typeName}
        </div>
        <ActivityCardContextMenu
          {...props2}
          manualMarkActivity={manualMarkActivity2}
        />
      </div>

      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center font-size-12 text-dark fw-400">
        </div>

        <div className="d-flex align-items-center font-size-12 text-dark fw-400">
          {" "}
          <img className="me-10" width={24} src={awicon} alt=""/>
          {activity.coins_earned ? activity.coins_earned: 0}
          /
          {total_coins ? total_coins : 2}
          {" "}
        </div>
      </div>

      <div className="question-count mt-2">
        <ul className="list-unstyled mb-0 d-flex align-items-center mt-1">
        </ul>
      </div>

      {manualMarkType && manual_mark_review === 0 && <>
        <div className="manual_mark_div">
          <span className="d-flex align-items-center gap-1">
            <i className="font-size-18 mdi mdi-alert-outline"></i>
            <p className="font-size-12 mb-0">
              Manual marking required
            </p>
          </span>
        </div>
      </>}

    </div>
  )
}
